function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, PRODUCTS */
/* global Button, Pill, Eyebrow, Icon, SectionHead, ProductCard, swatch */
// ============================================================================
// PDP — gallery on left (sticky), buy card on right.
// Editorial info sections below: details, fit, the cause, shipping.
// ============================================================================
var _React = React,
  useStatePdp = _React.useState,
  useEffectPdp = _React.useEffect;
function ProductDetailPage(_ref) {
  var product = _ref.product,
    _onAdd = _ref.onAdd,
    onCard = _ref.onCard,
    onBack = _ref.onBack;
  var productColors = product.colors || [];
  var productSizes  = product.sizes  || [];
  var _useStatePdp = useStatePdp(productSizes[1] || productSizes[0] || ""),
    _useStatePdp2 = _slicedToArray(_useStatePdp, 2),
    size = _useStatePdp2[0],
    setSize = _useStatePdp2[1];
  var _useStatePdp3 = useStatePdp(productColors[0] || ""),
    _useStatePdp4 = _slicedToArray(_useStatePdp3, 2),
    color = _useStatePdp4[0],
    setColor = _useStatePdp4[1];
  var _useStatePdp5 = useStatePdp(1),
    _useStatePdp6 = _slicedToArray(_useStatePdp5, 2),
    qty = _useStatePdp6[0],
    setQty = _useStatePdp6[1];
  var _useStatePdp7 = useStatePdp(0),
    _useStatePdp8 = _slicedToArray(_useStatePdp7, 2),
    img = _useStatePdp8[0],
    setImg = _useStatePdp8[1];
  var _useStatePdp9 = useStatePdp(false),
    _useStatePdp0 = _slicedToArray(_useStatePdp9, 2),
    added = _useStatePdp0[0],
    setAdded = _useStatePdp0[1];
  // variantImgs: { [colorName]: imageUrl }
  // Use baked-in map from rr-data.js (product.variantImages) — no async fetch needed.
  // Falls back to async Shopify product JSON fetch if baked-in data is absent.
  var _useStatePdpVI = useStatePdp(product.variantImages || {}),
    _useStatePdpVI2 = _slicedToArray(_useStatePdpVI, 2),
    variantImgs = _useStatePdpVI2[0],
    setVariantImgs = _useStatePdpVI2[1];
  useEffectPdp(function() {
    // If we already have baked-in variant images, skip the fetch
    if (product.variantImages && Object.keys(product.variantImages).length > 0) return;
    var handle = product.id;
    if (!handle) return;
    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || !data.product) return;
        var opts = data.product.options || [];
        var colorOptIdx = 0;
        for (var oi = 0; oi < opts.length; oi++) {
          var oname = (opts[oi].name || '').toLowerCase();
          if (oname.indexOf('color') !== -1 || oname.indexOf('colour') !== -1) { colorOptIdx = oi; break; }
        }
        var optKey = 'option' + (colorOptIdx + 1);
        var map = {};
        (data.product.variants || []).forEach(function(v) {
          var cname = v[optKey] || "";
          if (cname && v.featured_image && v.featured_image.src && !map[cname]) {
            map[cname] = v.featured_image.src.split('?')[0]; // strip query params
          }
        });
        setVariantImgs(map);
      })
      .catch(function() {});
  }, [product.id]);
  // Build gallery: deduplicate by stripping query params before comparison
  // product.img / product.imgAlt may have ?v=xxx?width=900 (malformed) — normalise first
  function stripQuery(url) { return url ? url.split('?')[0] : url; }
  var baseImgs = [product.img, product.imgAlt].filter(Boolean);
  var seen = {};
  baseImgs.forEach(function(u) { seen[stripQuery(u)] = true; });
  var variantOnly = Object.values(variantImgs).filter(function(u) { return u && !seen[stripQuery(u)]; });
  // Build gallery: for products with variantImages, order matches colors array
  // so thumbnail order is predictable (Black first, etc.)
  var orderedVariantImgs = [];
  if (productColors.length > 0 && Object.keys(variantImgs).length > 0) {
    productColors.forEach(function(c) {
      var u = variantImgs[c];
      if (u && !seen[stripQuery(u)]) {
        orderedVariantImgs.push(u);
        seen[stripQuery(u)] = true; // mark so it doesn't appear twice
      }
    });
    // Any remaining variantOnly not covered by productColors
    variantOnly.forEach(function(u) {
      if (!seen[stripQuery(u)]) { orderedVariantImgs.push(u); seen[stripQuery(u)] = true; }
    });
  } else {
    orderedVariantImgs = variantOnly;
  }
  var gallery = baseImgs.concat(orderedVariantImgs);
  // Placeholder for products with no images (e.g. mugs not yet mockupped)
  if (gallery.length === 0) {
    gallery = ['https://placehold.co/800x900/f4efe8/999999?text=' + encodeURIComponent(product.name || 'Image coming soon')];
  }
  var submit = function submit() {
    _onAdd(_objectSpread(_objectSpread({}, product), {}, {
      size: size,
      color: color,
      qty: qty
    }));
    setAdded(true);
    setTimeout(function () {
      return setAdded(false);
    }, 2000);
  };
  var related = PRODUCTS.filter(function (p) {
    return p.cause === product.cause && p.id !== product.id;
  }).slice(0, 4);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "24px 32px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      color: "var(--muted)"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      onBack();
    },
    style: {
      color: "inherit"
    }
  }, "Shop"), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0 8px"
    }
  }, "/"), /*#__PURE__*/React.createElement("span", null, product.cause), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: "0 8px"
    }
  }, "/"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--ink)"
    }
  }, product.name)), /*#__PURE__*/React.createElement("button", {
    onClick: onBack,
    style: {
      background: "transparent",
      border: "none",
      color: "var(--muted)",
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 6
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrowL",
    size: 12
  }), " Back")), /*#__PURE__*/React.createElement("section", {
    style: {
      padding: "20px 0 96px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.3fr) minmax(420px, 0.8fr)",
      gap: 64,
      alignItems: "flex-start"
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement(PdpGallery, {
    gallery: gallery,
    active: img,
    setActive: setImg,
    product: product
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: 96
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 10,
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: "rust"
  }, product.cause), product.badge && /*#__PURE__*/React.createElement(Pill, {
    tone: "ink"
  }, product.badge)), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(36px, 4.4vw, 68px)",
      lineHeight: 1.05,
      letterSpacing: "-0.015em",
      margin: 0,
      color: "var(--ink)"
    }
  }, product.name, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--rust)"
    }
  }, ".")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16,
      display: "flex",
      alignItems: "baseline",
      gap: 14
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 36,
      color: "var(--ink)"
    }
  }, "$", product.price.toFixed(2)), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: "var(--muted)",
      letterSpacing: "0.05em"
    }
  }, "USD \xB7 Printed in Los Angeles")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 20,
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: 18,
      lineHeight: 1.55,
      color: "var(--muted)",
      maxWidth: 540
    }
  }, product.desc), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 32,
      display: "flex",
      flexDirection: "column",
      gap: 28
    }
  }, productColors.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: pdpLabel
  }, /*#__PURE__*/React.createElement("span", null, "Color"), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--ink)"
    }
  }, color)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8,
      flexWrap: "wrap"
    }
  }, productColors.map(function (c) {
    return /*#__PURE__*/React.createElement("button", {
      key: c,
      onClick: function onClick() {
        setColor(c);
        // Switch main image to this color's variant image
        var vi = variantImgs[c];
        if (vi) {
          // Find by stripped URL to handle query-param mismatches
          var viClean = stripQuery(vi);
          var idx = gallery.findIndex(function(u) { return stripQuery(u) === viClean; });
          if (idx !== -1) { setImg(idx); }
        }
      },
      "aria-label": c,
      style: {
        background: "transparent",
        border: color === c ? "1px solid var(--ink)" : "1px solid transparent",
        padding: 3,
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        display: "block",
        width: 28,
        height: 28,
        background: swatch(c),
        border: "1px solid var(--line-2)",
        borderRadius: 999
      }
    }));
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: pdpLabel
  }, /*#__PURE__*/React.createElement("span", null, "Size"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    style: {
      color: "var(--muted)",
      fontSize: 12,
      textDecoration: "underline",
      textUnderlineOffset: 4
    }
  }, "Size guide")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: productSizes[0] === "One Size" ? "1fr" : "repeat(auto-fit, minmax(52px, 1fr))",
      gap: 8
    }
  }, productSizes.map(function (s) {
    return /*#__PURE__*/React.createElement("button", {
      key: s,
      onClick: function onClick() {
        return setSize(s);
      },
      style: {
        height: 48,
        background: size === s ? "var(--ink)" : "transparent",
        color: size === s ? "var(--bone)" : "var(--ink)",
        border: "1px solid " + (size === s ? "var(--ink)" : "var(--line-2)"),
        cursor: "pointer",
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 13,
        transition: "all 140ms"
      },
      onMouseEnter: function onMouseEnter(e) {
        if (size !== s) e.currentTarget.style.borderColor = "var(--ink)";
      },
      onMouseLeave: function onMouseLeave(e) {
        if (size !== s) e.currentTarget.style.borderColor = "var(--line-2)";
      }
    }, s);
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "120px 1fr",
      gap: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex",
      border: "1px solid var(--ink)",
      height: 56
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setQty(Math.max(1, qty - 1));
    },
    style: qBtn
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "minus",
    size: 14
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      flex: 1,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 14
    }
  }, qty), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setQty(qty + 1);
    },
    style: qBtn
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    size: 14
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: submit,
    style: {
      background: added ? "var(--forest)" : "var(--ink)",
      color: "var(--bone)",
      border: "1px solid " + (added ? "var(--forest)" : "var(--ink)"),
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: "0.04em",
      padding: "0 24px",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      gap: 10,
      transition: "background 200ms"
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!added) e.currentTarget.style.background = "var(--rust)";
      e.currentTarget.style.borderColor = "var(--rust)";
    },
    onMouseLeave: function onMouseLeave(e) {
      if (!added) e.currentTarget.style.background = "var(--ink)";
      e.currentTarget.style.borderColor = "var(--ink)";
    }
  }, added ? /*#__PURE__*/React.createElement(React.Fragment, null, "Added to cart ", /*#__PURE__*/React.createElement(Icon, {
    name: "heart",
    size: 14
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, "Add to cart \xB7 $", (product.price * qty).toFixed(2)))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: "var(--muted)",
      textAlign: "center",
      padding: "12px 0",
      borderTop: "1px solid var(--line)",
      borderBottom: "1px solid var(--line)"
    }
  }, "Or 4 payments of ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "var(--ink)"
    }
  }, "$", (product.price / 4).toFixed(2)), " with Shop Pay"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 16
    }
  }, [{
    ic: "package",
    t: "Printed to order",
    s: "Less waste, less ink"
  }, {
    ic: "truck",
    t: "Ships worldwide",
    s: "3–7 days from LA"
  }, {
    ic: "heart",
    t: "10% to the cause",
    s: "".concat(product.cause, " fund")
  }].map(function (m, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        display: "flex",
        flexDirection: "column",
        gap: 6
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: m.ic,
      size: 18,
      color: "var(--rust)"
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 13
      }
    }, m.t), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "var(--muted)"
      }
    }, m.s));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement(Accordion, {
    title: "Details & fabric",
    defaultOpen: true
  }, /*#__PURE__*/React.createElement("p", {
    style: pdpP
  }, "100% combed ring-spun cotton, 180gsm. Pre-shrunk. Double-needle hems. Hand-pulled water-based print, tear-away label, machine washable. Sourced from a unionised mill in Tirupur, India. OEKO-TEX Standard 100 certified.")), /*#__PURE__*/React.createElement(Accordion, {
    title: "The cause"
  }, /*#__PURE__*/React.createElement("p", {
    style: pdpP
  }, "Ten percent of profit on this piece funds organizations advancing ", product.cause.toLowerCase(), " work. Recent recipients include Planned Parenthood, Trans Lifeline, and several local mutual-aid networks.")), /*#__PURE__*/React.createElement(Accordion, {
    title: "The artist"
  }, /*#__PURE__*/React.createElement("p", {
    style: pdpP
  }, "Designed by ", /*#__PURE__*/React.createElement("strong", null, "Mira Okonkwo"), ", a Brooklyn-based illustrator and protest organizer. 100% of artist royalties go directly to Mira \u2014 no middlemen, no buyouts.")), /*#__PURE__*/React.createElement(Accordion, {
    title: "Shipping & returns"
  }, /*#__PURE__*/React.createElement("p", {
    style: pdpP
  }, "Printed on demand and shipped from Los Angeles in 3\u20135 business days. US standard 5\u20137 days. International 10\u201314 days. 30-day no-questions returns. Defects covered for life. If something rips at a protest, we'll replace it.")))))))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      background: "var(--shell)",
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 96,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "responsive-hide-tablet",
    style: {
      aspectRatio: "1/1.2",
      background: "linear-gradient(135deg, #1f1f1d, #0e0e0d)",
      position: "relative",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "radial-gradient(circle at 30% 70%, rgba(178,58,44,0.32), transparent 60%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      textAlign: "center",
      padding: 64
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: "clamp(22px, 4vw, 60px)",
      lineHeight: 1.1,
      color: "var(--bone)"
    }
  }, "\"", product.slogan, "\""), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 24,
      fontFamily: "var(--font-mono)",
      fontSize: 11,
      letterSpacing: "0.12em",
      color: "rgba(244,239,232,0.6)",
      textTransform: "uppercase"
    }
  }, "From the ", product.cause, " edit"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust"
  }, "The story"), /*#__PURE__*/React.createElement("h2", {
    style: {
      marginTop: 20,
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(32px, 4vw, 56px)",
      lineHeight: 1.05,
      letterSpacing: "-0.015em",
      color: "var(--ink)",
      margin: "20px 0 0"
    }
  }, "Designed to ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic"
    }
  }, "start a conversation.")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 24,
      fontSize: 17,
      lineHeight: 1.65,
      color: "var(--muted)"
    }
  }, "\"", product.slogan, "\" began as a hand-painted picket sign carried in three cities during 2025. We turned it into a wearable archive \u2014 a way to keep the slogan in circulation between protests, on bodies, in classrooms, in the street."), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 16,
      fontSize: 17,
      lineHeight: 1.65,
      color: "var(--muted)"
    }
  }, "The royalty on every sale goes to the artist who drew it. The cause percentage goes to the people doing the legal, mutual-aid, and organizing work that makes the slogan unnecessary one day."), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: ({"LGBTQ+": "/blogs/the-dispatch/sounds-gay-im-in-the-full-story", "Feminist": "/blogs/the-dispatch/intersectionality-why-it-matters", "Protest": "/blogs/the-dispatch/how-to-talk-to-someone-who-disagrees", "Humor": "/blogs/the-dispatch/youth-climate-strikes-growing-up"})[product.cause] || "/blogs/the-dispatch",
    style: { textDecoration: "none", color: "inherit" }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link"
  }, "Read the full essay ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 14
  }))))))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "More in the fight",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "From the same ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "edit."))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: 32
    },
    className: "responsive-4col"
  }, related.map(function (p) {
    return /*#__PURE__*/React.createElement(ProductCard, {
      key: p.id,
      p: p,
      onCard: onCard,
      onAdd: function onAdd(prod) {
        return _onAdd(_objectSpread(_objectSpread({}, prod), {}, {
          size: "M",
          color: (prod.colors || [])[0],
          qty: 1
        }));
      }
    });
  })))));
}

// ---- Gallery component -----------------------------------------------------
function PdpGallery(_ref2) {
  var gallery = _ref2.gallery,
    active = _ref2.active,
    setActive = _ref2.setActive,
    product = _ref2.product;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "84px 1fr",
      gap: 16
    },
    className: "responsive-gallery"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 12
    }
  }, gallery.map(function (src, i) {
    return /*#__PURE__*/React.createElement("button", {
      key: i,
      onClick: function onClick() {
        return setActive(i);
      },
      style: {
        background: "transparent",
        border: active === i ? "1px solid var(--ink)" : "1px solid var(--line)",
        padding: 0,
        cursor: "pointer",
        aspectRatio: "1/1.1"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: src,
      alt: "",
      style: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    }));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative",
      aspectRatio: "0.92/1.1",
      background: "var(--bone-2)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: gallery[active],
    alt: product.name,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  }), product.badge && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 20,
      left: 20
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    tone: product.badge === "NEW" ? "rust" : "ink"
  }, product.badge)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      bottom: 20,
      right: 20,
      fontFamily: "var(--font-mono)",
      fontSize: 10,
      color: "var(--bone)",
      background: "rgba(20,20,20,0.65)",
      padding: "4px 8px"
    }
  }, gallery.length > 1 ? (active + 1) + " / " + gallery.length : "")), /*#__PURE__*/React.createElement("style", null, "\n        @media (max-width: 700px) {\n          .responsive-gallery { grid-template-columns: 1fr !important; }\n          .responsive-gallery > div:first-child { flex-direction: row !important; }\n          .responsive-gallery > div:first-child > button { width: 64px !important; flex: none !important; }\n        }\n      "));
}

// ---- Accordion -------------------------------------------------------------
function Accordion(_ref3) {
  var title = _ref3.title,
    children = _ref3.children,
    _ref3$defaultOpen = _ref3.defaultOpen,
    defaultOpen = _ref3$defaultOpen === void 0 ? false : _ref3$defaultOpen;
  var _useStatePdp1 = useStatePdp(defaultOpen),
    _useStatePdp10 = _slicedToArray(_useStatePdp1, 2),
    open = _useStatePdp10[0],
    setOpen = _useStatePdp10[1];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    style: {
      width: "100%",
      background: "transparent",
      border: "none",
      padding: "18px 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 14,
      color: "var(--ink)"
    }
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    size: 16,
    style: {
      transform: open ? "rotate(45deg)" : "rotate(0)",
      transition: "transform 200ms"
    }
  })), open && /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: 20,
      animation: "fade-in 160ms"
    }
  }, children));
}
var pdpLabel = {
  display: "flex",
  justifyContent: "space-between",
  fontFamily: "var(--font-sans)",
  fontWeight: 500,
  fontSize: 12,
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: "var(--muted)",
  marginBottom: 12
};
var qBtn = {
  width: 36,
  height: "100%",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  color: "var(--ink)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
var pdpP = {
  fontFamily: "var(--font-sans)",
  fontSize: 14,
  lineHeight: 1.65,
  color: "var(--muted)",
  margin: 0
};
Object.assign(window, {
  ProductDetailPage: ProductDetailPage
});
